<template>
  <footer id="MainFooter" class="relative z-10 w-full py-10 bg-zinc-900">
    <div
      class="relative z-10 w-full max-w-screen-xl px-10 mx-auto lg:px-20"
      v-if="footer_data != null"
    >
      <div class="w-full pt-20">
        <router-link class="inline-block" to="/Home">
          <img
            width="192"
            height="50"
            src="/img/Logo.webp"
            class="w-48"
            alt="SavageBull 野蠻公牛"
          />
        </router-link>
        <ol class="mt-10 text-sm text-white">
          <li class="mb-2">電話：{{ footer_data.company_phone.content }}</li>
          <li class="mb-2">地址：{{ footer_data.company_address.content }}</li>
          <li class="mb-2">營業時間：{{ footer_data.company_time.content }}</li>
          <li class="mb-2">
            客服服務：{{ footer_data.company_support_time.content }}
          </li>
        </ol>
        <div class="flex items-center justify-start mt-10">
          <a
            @mouseenter="hover = 'facebook'"
            @mouseleave="hover = ''"
            :href="footer_data.company_facebook.content"
            target="_blank"
            class="mr-4 cursor-pointer"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 12.5C25 5.625 19.375 0 12.5 0C5.625 0 0 5.625 0 12.5C0 18.75 4.53125 23.9062 10.4688 24.8438V16.0937H7.34375V12.5H10.4688V9.6875C10.4688 6.5625 12.3438 4.84375 15.1563 4.84375C16.5625 4.84375 17.9688 5.15625 17.9688 5.15625V8.28125H16.4062C14.8438 8.28125 14.375 9.21875 14.375 10.1562V12.5H17.8125L17.1875 16.0937H14.2188V25C20.4688 24.0625 25 18.75 25 12.5Z"
                class="duration-300 transition-color"
                :class="
                  hover == 'facebook' ? 'fill-main-color' : 'fill-[#F6F6F6]'
                "
              />
            </svg>
          </a>
          <a
            @mouseenter="hover = 'instagram'"
            @mouseleave="hover = ''"
            class="mr-4 cursor-pointer"
            :href="footer_data.company_instagram.content"
            target="_blank"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 2.25904C15.8133 2.25904 16.2651 2.25904 17.6205 2.25904C18.8253 2.25904 19.4277 2.56024 19.8795 2.71084C20.4819 3.01205 20.9337 3.16265 21.3855 3.61446C21.8374 4.06627 22.1386 4.51807 22.2892 5.12048C22.4398 5.57229 22.5904 6.1747 22.741 7.37952C22.741 8.73494 22.741 9.03614 22.741 12.5C22.741 15.9639 22.741 16.2651 22.741 17.6205C22.741 18.8253 22.4398 19.4277 22.2892 19.8795C21.988 20.4819 21.8374 20.9337 21.3855 21.3855C20.9337 21.8374 20.4819 22.1386 19.8795 22.2892C19.4277 22.4398 18.8253 22.5904 17.6205 22.741C16.2651 22.741 15.9639 22.741 12.5 22.741C9.03614 22.741 8.73494 22.741 7.37952 22.741C6.1747 22.741 5.57229 22.4398 5.12048 22.2892C4.51807 21.988 4.06627 21.8374 3.61446 21.3855C3.16265 20.9337 2.86145 20.4819 2.71084 19.8795C2.56024 19.4277 2.40964 18.8253 2.25904 17.6205C2.25904 16.2651 2.25904 15.9639 2.25904 12.5C2.25904 9.03614 2.25904 8.73494 2.25904 7.37952C2.25904 6.1747 2.56024 5.57229 2.71084 5.12048C3.01205 4.51807 3.16265 4.06627 3.61446 3.61446C4.06627 3.16265 4.51807 2.86145 5.12048 2.71084C5.57229 2.56024 6.1747 2.40964 7.37952 2.25904C8.73494 2.25904 9.18675 2.25904 12.5 2.25904ZM12.5 0C9.03614 0 8.73494 0 7.37952 0C6.0241 0 5.12048 0.301206 4.36747 0.60241C3.61446 0.903615 2.86145 1.35542 2.10843 2.10843C1.35542 2.86145 1.05422 3.46386 0.60241 4.36747C0.301206 5.12048 0.150602 6.0241 0 7.37952C0 8.73494 0 9.18675 0 12.5C0 15.9639 0 16.2651 0 17.6205C0 18.9759 0.301206 19.8795 0.60241 20.6325C0.903615 21.3855 1.35542 22.1386 2.10843 22.8916C2.86145 23.6446 3.46386 23.9458 4.36747 24.3976C5.12048 24.6988 6.0241 24.8494 7.37952 25C8.73494 25 9.18675 25 12.5 25C15.8133 25 16.2651 25 17.6205 25C18.9759 25 19.8795 24.6988 20.6325 24.3976C21.3855 24.0964 22.1386 23.6446 22.8916 22.8916C23.6446 22.1386 23.9458 21.5361 24.3976 20.6325C24.6988 19.8795 24.8494 18.9759 25 17.6205C25 16.2651 25 15.8133 25 12.5C25 9.18675 25 8.73494 25 7.37952C25 6.0241 24.6988 5.12048 24.3976 4.36747C24.0964 3.61446 23.6446 2.86145 22.8916 2.10843C22.1386 1.35542 21.5361 1.05422 20.6325 0.60241C19.8795 0.301206 18.9759 0.150602 17.6205 0C16.2651 0 15.9639 0 12.5 0Z"
                class="duration-300 transition-color"
                :class="
                  hover == 'instagram' ? 'fill-main-color' : 'fill-[#F6F6F6]'
                "
              />
              <path
                d="M12.5 6.0241C8.88554 6.0241 6.0241 8.88554 6.0241 12.5C6.0241 16.1145 8.88554 18.9759 12.5 18.9759C16.1145 18.9759 18.9759 16.1145 18.9759 12.5C18.9759 8.88554 16.1145 6.0241 12.5 6.0241ZM12.5 16.7169C10.241 16.7169 8.28313 14.9096 8.28313 12.5C8.28313 10.241 10.0904 8.28313 12.5 8.28313C14.759 8.28313 16.7169 10.0904 16.7169 12.5C16.7169 14.759 14.759 16.7169 12.5 16.7169Z"
                class="duration-300 transition-color"
                :class="
                  hover == 'instagram' ? 'fill-main-color' : 'fill-[#F6F6F6]'
                "
              />
              <path
                d="M19.1265 7.37952C19.9583 7.37952 20.6325 6.70525 20.6325 5.8735C20.6325 5.04174 19.9583 4.36747 19.1265 4.36747C18.2948 4.36747 17.6205 5.04174 17.6205 5.8735C17.6205 6.70525 18.2948 7.37952 19.1265 7.37952Z"
                class="duration-300 transition-color"
                :class="
                  hover == 'instagram' ? 'fill-main-color' : 'fill-[#F6F6F6]'
                "
              />
            </svg>
          </a>
          <a
            class="cursor-pointer"
            @mouseenter="hover = 'youtube'"
            @mouseleave="hover = ''"
            :href="footer_data.company_youtube.content"
            target="_blank"
          >
            <svg
              width="26"
              height="18"
              viewBox="0 0 26 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.0714 2.73214C24.75 1.60714 23.9464 0.803572 22.8214 0.482143C20.8929 2.8738e-07 12.6964 0 12.6964 0C12.6964 0 4.66072 2.8738e-07 2.57144 0.482143C1.44644 0.803572 0.642852 1.60714 0.321424 2.73214C-4.9094e-06 4.82143 0 9 0 9C0 9 4.88545e-06 13.1786 0.482148 15.2679C0.803576 16.3929 1.60714 17.1964 2.73214 17.5179C4.66071 18 12.8571 18 12.8571 18C12.8571 18 20.8928 18 22.9821 17.5179C24.1071 17.1964 24.9107 16.3929 25.2322 15.2679C25.7143 13.1786 25.7143 9 25.7143 9C25.7143 9 25.7143 4.82143 25.0714 2.73214ZM10.2857 12.8571V5.14286L17.0357 9L10.2857 12.8571Z"
                class="duration-300 transition-color"
                :class="
                  hover == 'youtube' ? 'fill-main-color' : 'fill-[#F6F6F6]'
                "
              />
            </svg>
          </a>
        </div>
      </div>

      <div
        class="flex flex-col items-center justify-end w-full pt-20 text-sm text-white md:flex-row"
      >
        <p class="mb-2 md:mb-0 font-audiowide text-zinc-400">
          ©SAVAGEBULL 2022
        </p>
        <p class="hidden mx-5 md:block">・</p>
        <p class="text-zinc-400">
          網站設計：<a
            href="https://www.yongxin-design.com"
            class="text-main-color"
            >泳欣事業有限公司</a
          >
        </p>
      </div>
    </div>

    <div
      class="absolute top-0 left-0 right-0 bottom-0 z-[1] mix-blend-multiply"
      style="
        background-image: url('/img/bg_texture.webp');
        background-size: 80px;
      "
    ></div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      hover: "",
    };
  },
  computed: {
    footer_data() {
      return this.$store.state.footer_data;
    },
  },
  created() {
    this.footer_data == null ? this.$store.dispatch("GetFooterData") : "";
  },
};
</script>
